import { getSelectedLanguage } from 'i18n/utils';

export const LANGUAGE_STORAGE_KEY = 'i18nextLng';

/**
 * Adds a request interceptor that sets the Accept-Language header based on current i18next language
 * This ensures language changes are propagated to API requests immediately
 * @param {AxiosInstance} client - The axios instance to add interceptors to
 */
const addLanguageInterceptor = client => {
  client.interceptors.request.use(config => ({
    ...config,
    headers: {
      ...config.headers,
      'Accept-Language': getSelectedLanguage(),
    },
  }));
};

export default addLanguageInterceptor;
